const space = [
    0,
    '0.8rem',
    '1.6rem',
    '2.4rem',
    '3.2rem',
    '4rem',
    '4.8rem',
    '5.6rem',
    '6.4rem',
    '11.2rem',
] as const;

const halfSizesMap = {
    half0: '0.4rem', // xs
    half1: '1.2rem',
    half2: '2rem', // lg
    half3: '3.6rem',
    half4: '4.4rem', // xxxl
};

const spaceMap = {
    xs: '0.4rem',
    sm: '0.8rem',
    md: '1.6rem',
    lg: '2.0rem',
    xl: '2.4rem',
    xxl: '3.2rem',
    xxxl: '4.4rem',
} as const;

export default {
    space,
    halfSizesMap,
    spaceMap,
};
